import Lockr from 'lockr';
import KioskId from '@/lib/common/objects/KioskId';

class KioskSetup {

  private static singleton: KioskSetup | null = null;

  public static instance(): KioskSetup {
    if ( null === KioskSetup.singleton ) {
      KioskSetup.singleton = new KioskSetup();
    }
    return KioskSetup.singleton;
  }

  public readonly kioskId: KioskId;

  private constructor() {
    const id: string | null = Lockr.get('kb_kiosk_id', null);
    if ( null == id ) {
      const kioskId = KioskId.generateRandomId();
      Lockr.set('kb_kiosk_id', kioskId.getId());
      this.kioskId = kioskId;
    }
    else {
      this.kioskId = new KioskId(id);
    }
  }

}

export const kioskSetup = KioskSetup.instance();
